module.exports = __webpack_public_path__ + "vfn-assets/img/logo-viva-fan-white.9e9abf65.svg";